import React from 'react';
import ShuttleScheduler from './components/ShuttleScheduler';
import './App.css';

function App() {
  return (
    <div>
      <ShuttleScheduler />
    </div>
  );
}

export default App;
